import { chromeYellow, spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 8,
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  gap: 8,
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& > .MuiBox-root.richText': {
    color: spaceCadet[400],
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& .editor-shell': {
      color: spaceCadet[500],
    },

    '&.disabled': {
      '& .ContentEditable__root': {
        padding: 4,
        minHeight: 16,
        fontStyle: 'italic',
      },
      '& .Placeholder__root': {
        position: 'absolute',
        top: -4,
        left: 4,
        fontStyle: 'italic',
      },
    },
    '& .ContentEditable__root': {
      minHeight: 128,
    },
    '& .Placeholder__root': {
      position: 'absolute',
      left: 28,
      top: 46,
    },
    '& svg': {
      color: spaceCadet[500],
    },
    '& > .MuiBox-root.actions': {
      display: 'flex',
      gap: 4,
      '& > .MuiButton-text': {
        minWidth: 0,
        padding: 4,
        color: spaceCadet[400],
        fontWeight: 700,
        textTransform: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
        backgroundColor: 'transparent',
      },
    },
  },
  '& > .MuiAlert-root': {
    padding: 4,
    color: chromeYellow[500],
    backgroundColor: chromeYellow[100],
    '& .MuiAlert-message': {
      fontSize: 14,
      padding: 0,
      fontStyle: 'italic',
    },
    '& .MuiAlert-icon': {
      padding: 0,
      color: 'inherit',
    },
  },
});

export default StyledBox;
